/**
 * StatusTile — uniform tile chrome used in the 6-tile bento grid.
 *
 * Visual rules (per /app/design_guidelines.json):
 *   - Sharp 1px border, NO soft shadow by default.
 *   - On hover: lift -4 px + brutalist 4px-4px-0 #1A1A1A shadow.
 *   - Top: uppercase mono label + freshness tag.
 *   - Middle: BIG metric (Cabinet Grotesk-ish, currently Inter Bold).
 *   - Bottom: optional mini-viz / sparkline / trend arrow.
 */
import React from "react";
import { motion } from "framer-motion";
import { useFreshness } from "@/hooks/useFreshness";

export default function StatusTile({
  label,
  fetchedAt,
  children,
  accentColor,
  to,
  className = "",
  testid,
}) {
  const fresh = useFreshness(fetchedAt);
  const inner = (
    <motion.div
      whileHover={{ y: -5, rotate: -0.4 }}
      transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
      className={`group relative bg-[#121212] border border-white/10 rounded-2xl p-6 flex flex-col gap-3 transition-[box-shadow,border-color] cc-glow-green cursor-default ${className}`}
      style={accentColor ? { borderLeftColor: accentColor, borderLeftWidth: 3 } : undefined}
      data-testid={testid}
    >
      <div className="flex items-baseline justify-between gap-2">
        <span
          className="text-[10px] uppercase tracking-[0.22em] text-white/60 font-mono"
        >
          {label}
        </span>
        <span
          className="text-[10px] tracking-wide text-white/40 font-mono"
          title={fetchedAt}
        >
          {fresh}
        </span>
      </div>
      {children}
    </motion.div>
  );
  if (to) {
    return (
      <a href={to} className="block focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#00FA9A]">
        {inner}
      </a>
    );
  }
  return inner;
}
